<template>
  <el-dialog
    ref="dialogRef"
    v-bind="$attrs"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-on="$listeners"
  >
    <template #title>
      <div class="dialog-header">
        <template v-if="$slots.title">
          <slot name="title"></slot>
        </template>
        <div v-else class="title">{{ title }}</div>
        <img v-if="closeVisible" class="close-icon" src="@/assets/common/dialog-close.png" alt="" @click="close" />
      </div>
    </template>
    <el-divider v-if="headerDivider" class="divider" />
    <slot />
    <template #footer>
      <el-divider v-if="$slots.footer" class="divider" />
      <div class="dialog-footer" :class="[`footer--${footerAlign}`]">
        <slot name="footer" />
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'XYDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    headerDivider: {
      type: Boolean,
      default: false
    },
    closeVisible: {
      type: Boolean,
      default: true
    },
    // footer 对齐方式：center（默认居中）、left、right、between、around
    footerAlign: {
      type: String,
      default: 'center'
    }
  },
  methods: {
    close() {
      this.$emit('closed')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  border-radius: 24px;
  overflow: hidden;
  color: #333333;
  .el-dialog__header {
    padding: 20px 0;
    position: relative;
  }

  .el-dialog__body {
    padding: 0 28px;
    font-size: 18px;
  }

  .el-dialog__footer {
    padding: 20px 28px;
  }
}

::v-deep .divider.el-divider {
  margin: 0 0 20px 0;
  background-color: #e5e5e5;
}

.dialog-header {
  padding: 0 28px;
  .title {
    font-weight: bold;
    font-size: 20px;
  }

  .close-icon {
    width: 62px;
    height: 62px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
}

.dialog-footer {
  display: flex;
  align-items: center;

  // 默认居中（兼容旧逻辑）
  &.footer--center {
    width: 100%;
    margin: auto;
    justify-content: center;
  }

  &.footer--left {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
  }

  &.footer--right {
    width: 100%;
    max-width: 100%;
    justify-content: flex-end;
  }

  &.footer--between {
    width: 100%;
    max-width: 100%;
    justify-content: space-between;
  }

  &.footer--around {
    width: 100%;
    max-width: 100%;
    justify-content: space-around;
  }
}
</style>
